export default function XMLVEditSupport() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Support - XML Viewer &amp; Editor
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Help, troubleshooting, and contact details for XML Viewer &amp;
            Editor.
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <h2 className="text-2xl font-bold text-[#A8720E]">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I open an XML file?
              </h3>
              <p className="mt-1">
                You can paste XML from the clipboard, open a file from your
                device, type or paste XML manually, fetch XML from a URL, or
                start with a blank document using the + button.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I view the XML tree?
              </h3>
              <p className="mt-1">
                After loading XML, the viewer opens with three tabs: Tree
                (visual hierarchy), Formatted (syntax-highlighted text), and
                Edit (editable text). The tree view lets you expand/collapse
                nodes, copy elements, and navigate using breadcrumbs.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I compare two XML files?
              </h3>
              <p className="mt-1">
                Use the Compare feature from the home screen or from the viewer
                menu. Paste or load XML into both panels and tap Compare.
                Differences are highlighted as added, removed, or changed.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I use XPath queries?
              </h3>
              <p className="mt-1">
                In the viewer, tap the search icon and switch to XPath mode.
                Enter an XPath expression like{" "}
                <code className="rounded bg-[#F1EEE5] px-1 py-0.5 text-[#A8720E]">
                  //item/title
                </code>{" "}
                to find matching nodes.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I export XML?
              </h3>
              <p className="mt-1">
                From the viewer menu, you can save to device, export as PDF,
                export as Excel, print, convert to JSON, or share the XML
                directly. PDF and Excel exports may require watching a short ad
                or purchasing ad-free.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I fix invalid XML?
              </h3>
              <p className="mt-1">
                XMLVEdit automatically attempts to fix common XML issues like
                unclosed tags, unquoted attributes, and missing declarations
                when you open malformed XML.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Why does the app show ads?
              </h3>
              <p className="mt-1">
                Ads help support continued development. You can remove all ads
                with a one-time in-app purchase from Settings.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I change the language?
              </h3>
              <p className="mt-1">
                Go to Settings and tap Language. XMLVEdit supports 15 languages
                including English, Hindi, Spanish, Portuguese, Arabic, Chinese,
                Japanese, Korean, and more.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Support</h2>
          <p>
            For help, bug reports, or privacy-related questions, email{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            . We usually respond within 24-48 hours.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Report a Bug</h2>
          <p>
            If something is not working as expected, include these details in
            your email:
          </p>
          <ul className="list-disc space-y-1 pl-6">
            <li>Your device model and OS version</li>
            <li>Your app version (found in Settings &gt; About)</li>
            <li>What you were trying to do</li>
            <li>The error or unexpected result</li>
            <li>Steps to reproduce the issue, if known</li>
            <li>A sample XML file if relevant</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">Important Links</h2>
          <ul className="list-disc space-y-1 pl-6">
            <li>
              Privacy Policy:{" "}
              <a
                href="/apps/xmlvedit/privacy-policy"
                className="text-[#0F6BBF] underline"
              >
                cosmovexapps.com/apps/xmlvedit/privacy-policy
              </a>
            </li>
            <li>
              Support:{" "}
              <a
                href="/apps/xmlvedit/support"
                className="text-[#0F6BBF] underline"
              >
                cosmovexapps.com/apps/xmlvedit/support
              </a>
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">App Information</h2>
          <ul className="list-disc space-y-1 pl-6">
            <li>
              <strong>App Name:</strong> XML Viewer &amp; Editor
            </li>
            <li>
              <strong>Package:</strong> com.cosmovex.xmlvedit
            </li>
            <li>
              <strong>Developer:</strong> Cosmovex
            </li>
            <li>
              <strong>Contact:</strong>{" "}
              <a
                href="mailto:trionapps@gmail.com"
                className="text-[#0F6BBF] underline"
              >
                trionapps@gmail.com
              </a>
            </li>
          </ul>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-sm text-[#8A93A2]">
          &copy; 2026 Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
